/* Stylesheet */

.bullet_container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .bullet_track {
    display: flex;
    align-items: center;
    gap: 8px;
    transition: transform 0.25s ease-in-out;
  }
}
